<template>
  <div class="market-couponGrantAccount-add">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <div class="base-config">
        <div class="title">基础配置</div>
        <el-form-item label="活动名称" prop="activityName">
          <el-input type="text" v-model="form.activityName" placeholder="请输入活动名称"/>
        </el-form-item>
        <el-form-item label="活动时间" prop="activityTime">
          <el-date-picker
            v-model="form.activityTime"
            type="datetimerange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="券名称" prop="name">
          <el-input type="text" v-model="form.name" placeholder="请输入券名称"/>
        </el-form-item>

        <el-form-item label="面额" prop="amount" >
          <el-input type="text" v-model="form.amount" placeholder="请输入面额" oninput="value=value.replace(/[^.\d.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <div class="apportion-set" v-if="form.amount">
          <el-form-item label="分摊设置" >
            （商场与店铺分摊优惠券费用，默认分摊比例为0；双方承担总费用为100%）
          </el-form-item>
          <el-form-item label="商场承担费用" prop="mallCostRate" label-width="200px">
            <el-input type="text" v-model="form.mallCostRate" oninput="value=value.replace(/[^.\d.]/g,'')" style="width: 250px;">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="店铺承担费用" prop="storeCostRate" label-width="200px">
            <el-input type="text" v-model="form.storeCostRate" oninput="value=value.replace(/[^.\d.]/g,'')" style="width: 250px;">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>

        <el-form-item label="使用门槛" prop="requireAmount" >
          <el-input type="text" v-model="form.requireAmount" oninput="value=value.replace(/[^.\d.]/g,'')">
            <template slot="prepend">订单满</template>
            <template slot="append">元可用</template>
          </el-input>
          <span class="input-remark">（0元代表无门槛）</span>
        </el-form-item>

        <el-form-item label="用券时间" prop="days">
          <el-input type="text" v-model="form.days" oninput="value=value.replace(/[^\d]/g,'')">
            <template slot="prepend">领/发当日生效</template>
            <template slot="append">天内有效</template>
          </el-input>
        </el-form-item>

        <div class="range-select">
          <el-form-item label="使用范围" prop="useRangeType">
            <el-radio-group v-model="form.useRangeType">
              <el-radio label="Generic">店铺通用</el-radio>
              <el-radio label="Store">指定店铺</el-radio>
              <el-radio label="Category">
                <span>指定业态</span>
                <span style="font-size: 12px; color: #999;">（仅支持一级）</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.useRangeType === 'Store'" class="store-select-box" prop="storeIds" label="" label-width="0">
            <el-cascader
              v-model="form.storeIds"
              placeholder="请选择店铺"
              :options="shopTreeData"
              :props="shopCascaderProps"
              clearable
              collapse-tags
              :filterable="true"
              :show-all-levels="false"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item v-if="form.useRangeType === 'Category'" class="category-select-box" prop="categories" label="" label-width="0">
            <el-select v-model="form.categories" placeholder="请选择业态" filterable multiple collapse-tags>
              <el-option v-for="item in shopCategoryData" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="发放次数" prop="frequency">
          <el-radio-group v-model="form.frequency">
            <el-radio label="1">
              <span>各ID发放一次</span>
              <span style="font-size: 12px; color: #999;">（预计发放券数量为：{{memberCount}}张）</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>

    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">确定</el-button>
    </div>
  </div>
</template>

<script>
import {api_postAccountCouponGrantAdd} from '@/api/market'
import { api_getConfig, api_getMemberCount } from "@/api/common";

export default {
  name: "mcgaAdd",
  data() {
    // 校验金额
    const checkAmount = (rule, value, callback) => {
      const check = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value && !check.test(value)) {
        callback(new Error('请输入数字，最多保留两位小数'))
      } else if (!value && rule.field == 'maxAmount' || value && check.test(value)) {
        callback()
      } else {
        callback(new Error('请输入'))
      }
    }

    // 校验正整数---天数
    const checkInt = (rule, value, callback) => {
      const check = /(^[0-9]\d*$)/;
      if (!check.test(value)) {
        callback(new Error('请输入天数'))
      } else {
        callback()
      }
    }

    // 校验分摊比例
    const checkApportion = (rule, value, callback) => {
      const check = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      const storeCostRate = this.form.storeCostRate || undefined
      const mallCostRate = this.form.mallCostRate || undefined

      if (!check.test(value)) {
        callback(new Error('请输入0~100之间的数字，最多保留两位小数'))
      } else if (parseFloat(value) > 100) {
        rule.field == 'storeCostRate' && (this.form.storeCostRate = parseFloat(value) > 100 ? 100 : value)
        rule.field == 'mallCostRate' && (this.form.mallCostRate = parseFloat(value) > 100 ? 100 : value)
      } else if (rule.field == 'mallCostRate' && parseFloat(value) + parseFloat(storeCostRate) > 100) {
        callback(new Error('商场承担费用+店铺承担费用 不能大于100%'))
      } else if (rule.field == 'storeCostRate' && parseFloat(value) + parseFloat(mallCostRate) > 100) {
        callback(new Error('商场承担费用+店铺承担费用 不能大于100%'))
      } else if (
        (rule.field == "mallCostRate" &&
          storeCostRate &&
          parseFloat(value) + parseFloat(storeCostRate) < 100) ||
        (rule.field == "storeCostRate" &&
          mallCostRate &&
          parseFloat(value) + parseFloat(mallCostRate) < 100)
      ) {
        callback(new Error('商场承担费用 与 店铺承担费用 之和应为100%'))
      } else {
        callback()
      }
    }

    return {
      submitLoading: false,
      form: {
        type: 'CashCoupon',
        effectiveType: 'Unfixed',
        waitDays:'0',
        frequency: '1',
        issueType: 'Auto', // 发放类型默认自动发放
      },
      rules: {
        activityName: [{required: true, message: '请输入活动名称'}],
        activityTime: [{required: true, message: '请选择活动时间'}],
        name: [{required: true, message: '请输入券名称'}],
        amount: [{required: true, validator: checkAmount}],
        requireAmount: [{required: true, validator: checkAmount}],
        useRangeType: [{required: true, message: '请选择使用范围'}],
        days: [{required: true, validator: checkInt}],
        mallCostRate: [{required: true, validator: checkApportion}],
        storeCostRate: [{required: true, validator: checkApportion}],
      },

      discountData: [], // 折扣下拉框数据
      shopTreeData: [], // 店铺级联框树形数据
      shopCategoryData: [], // 业态数据
      shopCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项
      categoryCascaderProps: {
        multiple: true,
        value: "name",
        label: "name",
      }, // 业态级联框配置项
      memberCount: 0, // 会员数量
    };
  },
  created() {
    this.getConfigData() // 获取店铺级联框、折扣枚举数据
    this.getMemberCount() // 获取会员数量
  },
  methods: {
    // 获取店铺级联框数据
    async getConfigData() {
      let {storeThreeLevel, discount, category} = await api_getConfig(['storeThreeLevel', 'discount', 'category'])
      this.discountData = discount
      this.shopTreeData = storeThreeLevel
      this.shopCategoryData = category
    },

    // 获取会员数量
    async getMemberCount() {
      const res = await api_getMemberCount()
      this.memberCount = res || 0
    },

    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let params = {
              ...this.form,
            }

            // 处理活动时间
            params.startTime = this.form.activityTime ? this.form.activityTime[0] : null // 开始
            params.endTime = this.form.activityTime ? this.form.activityTime[1] : null // 结束

            delete params.activityTime
            console.log('params: ', params);
            // return

            const res = await api_postAccountCouponGrantAdd(params)
            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch (error) {
            console.log('error: ', error);
            this.submitLoading = false
          }
        }
      })
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.market-couponGrantAccount-add {
  padding: 35px 20px 0 20px;
  padding-bottom: 100px;
  box-sizing: border-box;

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #999999;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .base-config {
    // margin-top: 20px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 30px;

    .range-select {

      .store-select-box {
        margin-left: 240px;
        margin-top: -20px;
      }

      .category-select-box {
        margin-left: 350px;
        margin-top: -20px;
      }
    }
  }

  ::v-deep {
    .el-radio-group {
      .el-radio-button__inner {
        height: 34px;
        padding: 0;
        line-height: 34px;
        margin-right: 1px;
        width: 100px;
        border: 0;
      }

      .el-radio-button:first-child {
        .el-radio-button__inner {
          border-radius: 2px 0px 0 0;
        }
      }

      .el-radio-button:last-child {
        .el-radio-button__inner {
          border-radius: 0 2px 0 0;
        }
      }
    }

    .el-input,
    .el-textarea,
    .el-select {
      width: 350px;
    }

    .short.el-input {
      width: 156px;
    }

    .el-range-editor.el-input__inner {
      width: 350px;
      background: #F2F3F5;
      border: 0;

      input {
        background: #F2F3F5;
        border: 0;
      }
    }

    .el-range-editor.el-input__inner.is-active {
      width: 350px;
      background: #fff;
      border: 1px solid #05C8AF;

      input {
        background: #fff;
        border: 0;
      }
    }

    .desc {
      color: #999;
      font-size: 12px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    z-index: 999;
  }
}
</style>
